import React, { Component } from 'react'
import { Text, View, ScrollView ,Platform} from 'react-native'
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Theme from '../../theme';
import moment from 'moment-timezone';
import { FormError } from '../../ui';
import { Equipment } from 'fitbeat.models';
import { ProcessTypes } from 'fitbeat.gym-core';
import { getNextBookingStep } from '../actions';
import { Button, ButtonTypes } from '../../components';
import { i18n, getSlotTime, Logger } from '../../utils';
import { BookingFlowFooter } from '../components';
import WorkoutSettingSection from '../components/WorkoutSettingSection';
import { styles, getResponsiveStyleSheet } from '../components/Styles'
import { styles as sharedStyles } from './Styles';
import { BodyweightIcon, DumbbellsIcon } from '../../ui/components/Icons';
import { EquipmentList } from '../../ui/components';
const responsive = getResponsiveStyleSheet();

class SelectEquipment extends Component {
  static getSubtitle = ({ workoutSession }) => {
    const bookingTime = workoutSession.startTimeOfFirstExercise;
    return (
      <View style={sharedStyles.subtitleContainer}>
        <Text style={sharedStyles.subtitle}>
          {moment(bookingTime).format('dddd')}
        </Text>
        <View style={sharedStyles.verticalSeparator} />
        <Text style={sharedStyles.subtitle}>
          {moment(bookingTime).format('DD MMM')}
        </Text>
        <View style={sharedStyles.verticalSeparator} />
        <Text style={sharedStyles.subtitle}>
          {moment(bookingTime).format('HH:mm')}
        </Text>
        <View style={sharedStyles.verticalSeparator} />
        <Text style={sharedStyles.subtitle}>
          {getSlotTime(workoutSession)}
        </Text>
      </View>
    )
  };

  constructor(props) {
    super(props)

    this.state = {
      workoutSettings: props.workoutSession,
      error: null,
      isLoading: false
    }
  }

  componentDidUpdate = async (prevProps) => {
    if (JSON.stringify(prevProps.workoutSettings) !== JSON.stringify(this.props.workoutSettings)) {
      await this.setState({ workoutSettings: this.props.workoutSettings });
    }
  }

  saveEquipmentList = async () => {
    try {
      await this.setState({ isLoading: true, error: null });
      const { userProfile, userProfileService, getNextBookingStep } = this.props;
      const { workoutSettings } = this.state;
      const { equipment = [Equipment.Bodyweight] } = workoutSettings;
      userProfile.defaultEquipment = equipment;
      await userProfileService.updateUserProfile(userProfile);
      getNextBookingStep(userProfile, ProcessTypes.WorkoutSettings);
    } catch (error) {
      this.setState({ error: new Error('Oops, something went wrong.') });
      Logger.notify(error);
    } finally {
      await this.setState({ isLoading: false });
    }
  }

  toggleEquipment = (workoutEquipment) => {
    const { workoutSettings } = this.state;
    const { equipment = [Equipment.Bodyweight] } = workoutSettings;
    workoutSettings.equipment = workoutEquipment.sort();
    this.setState({ workoutSettings });
  }

  render() {
    console.warn("HELLO")
    const { t } = this.props;
    const { workoutSettings, error, isLoading } = this.state;
    const { equipment = [Equipment.Bodyweight] } = workoutSettings;
    const flexContainer = Platform.OS !== 'web' ? {} : { flexGrow: 0.2 }

    return (
      <View style={sharedStyles.container}>
        <Text style={styles.settingsHeader}>{t('equipment').toUpperCase()}</Text>
        <ScrollView contentContainerStyle={flexContainer}>
          <EquipmentList
            rowDisplay={false}
            currentSelectedEquipment={equipment}
            onCompleteEquipmentChange={this.toggleEquipment}
          />
        </ScrollView>
        <BookingFlowFooter>
          <FormError error={error} />
          <Button
            title={t('accept')}
            isLoading={isLoading}
            fontColor={Theme.WHITE}
            buttonType={ButtonTypes.NORMAL}
            onPress={this.saveEquipmentList}
          />
        </BookingFlowFooter>
      </View >
    )
  }
}

const mapStateToProps = (state) => {
  return {
    workoutSession: state.bookings.bookingWizard.workoutSession,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getNextBookingStep: (userProfile, processType) => dispatch(getNextBookingStep(userProfile, processType)),
  };
};

SelectEquipment = connect(mapStateToProps, mapDispatchToProps)(SelectEquipment);
export default translate(['bookings'], { wait: true })(SelectEquipment);
